<template>
  <v-edit-dialog
    large
    @save="save"
    @open="open"
    save-text="SALVAR"
    cancel-text="CANCELAR"
    :return-value.sync="editText">
    <px-situacao-cotacao-icon :situacao="cotacao.situacao"/>
    <px-span-tooltip top :text="identificador" :tooltip="cotacao.identificador"/>
    <template v-slot:input>
      <px-edit-identificador v-model="editText"/>
    </template>
  </v-edit-dialog>
</template>

<script>
import Vue from 'vue';
import CotacaoService from '../cotacao-service';

export default {
  props: {
    cotacao: Object,
    saveFunction: {
      type: Function,
      default: CotacaoService.updateIdentifier,
    },
  },
  data() {
    return {
      editText: null,
    };
  },
  computed: {
    identificador() {
      return Vue.filter('truncate')(this.cotacao.identificador, 10);
    },
  },
  methods: {
    buildCotacao() {
      return {
        id: this.cotacao.id,
        identificador: this.editText,
      };
    },
    saveIdentifier() {
      this.saveFunction(this.cotacao.id, this.buildCotacao())
        .then(() => {
          this.$toast('Identificador atualizado', { color: 'success' });
          this.$emit('update');
        });
    },
    save() {
      this.saveIdentifier();
    },
    open() {
      this.editText = this.cotacao.identificador;
    },
  },
};
</script>
